var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 4V5.6M7.19995 4V5.6",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9962 12.7998H12.0034M11.9962 15.9998H12.0034M15.1926 12.7998H15.1998M8.7998 12.7998H8.80698M8.7998 15.9998H8.80698",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19995 8.7998H18.8",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3999 12.1944C4.3999 8.70856 4.3999 6.96563 5.4016 5.88272C6.40329 4.7998 8.01549 4.7998 11.2399 4.7998H12.7599C15.9843 4.7998 17.5965 4.7998 18.5982 5.88272C19.5999 6.96563 19.5999 8.70856 19.5999 12.1944V12.6052C19.5999 16.0911 19.5999 17.834 18.5982 18.9169C17.5965 19.9998 15.9843 19.9998 12.7599 19.9998H11.2399C8.01549 19.9998 6.40329 19.9998 5.4016 18.9169C4.3999 17.834 4.3999 16.0911 4.3999 12.6052V12.1944Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7998 8.7998H19.1998",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarActive);
export default __webpack_public_path__ + "static/media/calendar-active.fd3098c48bd9e712360a0c0d33db73e1.svg";
export { ForwardRef as ReactComponent };